import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useUserRentsStore } from '../store/userRentsStore';
import { useEffect } from 'react';

export const useGetActiveRents = () => {
  const { actions } = useUserRentsStore();
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['rents'],
    queryFn: () => API.getActiveRents(),
    //retry: 1,
    select: (data) => data.data.payload,
    refetchOnWindowFocus: 'always',
    refetchInterval: 2000,
  });

  useEffect(() => {
    if (isSuccess) {
      actions.setUserRents({
        loading: false,
        rents: data.filter((rent) => rent.status === 'in_progress'),
      });
    }
  }, [isSuccess]);

  return { rents: data, isLoading, refetch, isSuccess };
};
